/**
 * Detects if any items in the cart have been deleted from the menu.
 * Since deleted items are filtered out at the Firestore query level,
 * they won't appear in the available menuItems array. We cross-reference
 * the cart items against the available menu to find deleted ones.
 */
const detectDeletedItemsInCartFun = (currentOrder, menuItems = []) => {
  if (!currentOrder?.menuItems?.length || !menuItems?.length) return false;

  const availableMenuItemIds = new Set(menuItems.map((item) => item._id));

  return currentOrder.menuItems.some(
    (item) => !availableMenuItemIds.has(item._id)
  );
};

export const detectDeletedItemsInCart = detectDeletedItemsInCartFun;
